import type { TechnicalInfoData, TechnicalInfoDataDTO } from "~/features/search/models/SearchResultsDTO";

export const transformTechnicalInfo = (technicalInfo: TechnicalInfoDataDTO | null): TechnicalInfoData | null => {
  if (!technicalInfo) {
    return null;
  }

  if (!technicalInfo.columns) {
    return { ...technicalInfo, columns: technicalInfo.columns };
  }

  return {
    ...technicalInfo,
    columns: technicalInfo.columns.map((column) => ({
      ...column,
      items: (column.items ?? []).map(({ downloadUrl, pageUrl, ...rest }) => ({
        ...rest,
        url: downloadUrl ?? pageUrl ?? "",
      })),
    })),
  };
};
